<template>
  <div class="inner-content">
    <div class="flex-row search-row-section">
      <div class="flex-row-item flex-search-input">
        <search-input />
      </div>
    </div>
    <div class="main-table-container">
      <search-results />
    </div>
    <delete-confirmation>
      <template slot="name">
        {{ asset.title }}
      </template>
      <template slot="body">
        Are you sure?
      </template>
    </delete-confirmation>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SearchInput from '../../assets/shared/SearchInput'
import SearchResults from '../../shared/SearchResults.vue'
import searchKeys from '../../../mixins/search-keys'
import DeleteConfirmation from '../../assets/shared/DeleteConfirmation'

export default {
  name: 'LmsUserSearch',
  components: {
    SearchInput,
    SearchResults,
    DeleteConfirmation
  },
  mixins: [searchKeys],
  computed: {
    ...mapGetters([
      'asset'
    ])
  },
  async mounted () {
    this.setAssetType({ assetType: 'admin_user' })

    const keys = [
      { key: 'ids', display_name: 'IDs', type: 'text' },
      { key: 'first_name', display_name: 'First Name', type: 'text' },
      { key: 'last_name', display_name: 'Last Name', type: 'text' },
      { key: 'email', display_name: 'Email', type: 'text' },
      { key: 'is_admin', display_name: 'Is Admin?', type: 'boolean' }
    ]
    this.setAvailableKeys(keys)
  },
  methods: {
    ...mapMutations([
      'setAssetType'
    ])
  }
}
</script>
<style lang="scss">
.table-container {
  border: solid 1px $grey-3;
}
</style>
